import _defineProperty from "C:/Users/gilbe/OneDrive/Documents/GitHub/luth-main/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { createStyles } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref, getRef) {
  var spacing = _ref.spacing,
      center = _ref.center;
  var itemWrapper = {
    ref: getRef("itemWrapper"),
    display: "inline"
  };
  return {
    itemWrapper: itemWrapper,
    item: {
      lineHeight: center ? 1 : theme.lineHeight,
      "&:not(:first-of-type)": {
        marginTop: theme.fn.size({
          size: spacing,
          sizes: theme.spacing
        })
      }
    },
    withIcon: _defineProperty({
      listStyle: "none"
    }, "& .".concat(itemWrapper.ref), {
      display: "inline-flex",
      alignItems: center ? "center" : "flex-start"
    }),
    itemIcon: {
      display: "inline-block",
      verticalAlign: "middle",
      marginRight: theme.spacing.sm
    }
  };
});
export default useStyles;